import React from 'react'
import { Link } from 'react-router-dom'
import styles from './Payment.module.css'

const Payment = () => {
    return (
        <div className={styles.container}>
            <div className={styles.box}></div>
            <header>
                <Link to="/confirm-info">
                    <i className={styles.backIcon + " fas fa-chevron-left"}></i>
                </Link>
                <h1>Payment modes</h1>
            </header>
            <main>
                <h4>Select Payment Mode</h4>
                <div className={styles.inputContainer}>
                    <p>
                        <input type="radio" id="test1" name="radio-group" checked />
                        <div className={styles.textContainer}>
                            <h3>Cash on Pickup</h3>
                            <p>Pay while pick a delivery</p>
                        </div>
                    </p>
                    <p>
                        <input type="radio" id="test2" name="radio-group" />
                        <div className={styles.textContainer}>
                            <h3>Cash on Pickup</h3>
                            <p>Pay while pick a delivery</p>
                        </div>
                    </p>
                    <p>
                        <input type="radio" id="test3" name="radio-group" />
                        <div className={styles.textContainer}>
                            <h3>Cash on Pickup</h3>
                            <p>Pay while pick a delivery</p>
                        </div>
                    </p>
                </div>
            </main>
            <Link to="/pickup-assigned">
                <button>Proceed to Payment</button>
            </Link>
        </div>
    )
}

export default Payment
